import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios, { Axios } from 'axios';
import './PaymentPage.css';
import Spinner from './components/Spinner';
import { useOutletContext } from 'react-router-dom';
async function createOperationRequest(productI, phoneNumberI, token, setError, setLoading, setPaymentStatus, location_required, forced = false) {
    let product = productI;
    let phoneNumber = phoneNumberI;
    let locationUrl = null;
    if (location_required) {
        locationUrl = await new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const link = `https://www.google.com/maps/search/?api=1&query=${position.coords.latitude},${position.coords.longitude}`;
                        resolve(link);
                    },
                    (error) => {
                        setError('يجب تفعيل الموقع الجغرافي للمتابعة');
                        setLoading(false);
                        setPaymentStatus('failed');
                        reject(null);
                    }
                );
            } else {
                setError('يجب تفعيل الموقع الجغرافي للمتابعة');
                setLoading(false);
                setPaymentStatus('failed');
                reject(null);
            }
        });
        if (!locationUrl) return {};
    }
    const response = await axios.post("https://rechargemoi.ma/backend/api/operations/create", {
        productId: product.productId,
        productName: product.productName,
        client: phoneNumber,
        finalPrice: product.finalPrice,
        location: locationUrl,
        forced: forced
    }, {
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    });
    return response.data;
}
async function validateOperation(operationId, token, refNumber, res) {
    console.log("Validating operation with refNumber:", refNumber, "and response:", res);
    let success = 0
    if (refNumber) {
        success = 1
    }
    const response = await axios.post("https://rechargemoi.ma/backend/api/operations/" + operationId, {
        refNumber: refNumber,
        success: success,
        response: success === 0 ? res.data ?? res?.response?.data ?? res?.response?.status : res
    }, {
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    });
    return response.data;
}
async function createCart(headers) {
    const response = await axios.post("https://api.inwi.ma/api/v1/ms-payment/cart/create", {}, {
        headers: headers
    }
    );
    return response.data;
}
async function addTocart(cartId, productId, headers, client) {
    const response = await axios.post(`https://api.inwi.ma/api/v1/ms-payment/cart/add`, {
        productId: productId,
        qty: 1,
        cartId: cartId,
        custom_options: [
            {
                name: "mdn",
                value: client
            }
        ]
    }, {
        headers: headers
    });
    return response.data;
}
async function pay(cartId, headers) {
    const response = await axios.post(`https://api.inwi.ma/api/v1/ms-payment/recharge/etoile9`, {
        cartId: cartId,
        items: [],
    }, {
        headers: headers
    }
    );
    return response.data;
}
let userGMPLink = null
let locationEnabled = false
function PaymentPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [error, setError] = useState(null);
    const [paymentAttempted, setPaymentAttempted] = useState(false);
    const abortControllerRef = React.useRef(null);
    const paymentInitiatedRef = React.useRef(false);
    // Extract payment data from location state
    const { product, phoneNumber } = location.state || {};
    const { balance, limit, first, offer, location_required, serverPayment } = useOutletContext();
    async function askForLocationPermission() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    locationEnabled = true;
                    userGMPLink = `https://www.google.com/maps/search/?api=1&query=${position.coords.latitude},${position.coords.longitude}`;
                },
                (error) => {
                    setError('يجب تفعيل الموقع الجغرافي للمتابعة');
                    setLoading(false);
                    setPaymentStatus('failed');
                }
            );
        } else {
            setError('يجب تفعيل الموقع الجغرافي للمتابعة');
            setLoading(false);
            setPaymentStatus('failed');
        }
    }
    useEffect(() => {
        // Prevent duplicate payment processing (handles React StrictMode double-calls)
        if (paymentInitiatedRef.current) return;
        paymentInitiatedRef.current = true;

        // If no product data, redirect back to home
        if (!product || !phoneNumber) {
            navigate('/');
            return;
        }
        // // Generate a transaction key based on product ID and phone number
        // const transactionKey = `payment_${product.productId}_${phoneNumber}`;

        // // Check if this payment has already been processed
        // const existingTransaction = sessionStorage.getItem(transactionKey);

        // if (existingTransaction) {
        //     // Parse the stored transaction data
        //     const transactionData = JSON.parse(existingTransaction);

        //     // Set the stored payment status
        //     setPaymentStatus(transactionData.status);
        //     if (transactionData.status === 'failed') {
        //         setError(transactionData.error || 'فشلت عملية الدفع سابقًا');
        //     }

        //     // Mark that payment was already attempted
        //     setPaymentAttempted(true);

        //     console.log('تمت محاولة الدفع مسبقًا:', transactionData);
        // } else {
        //     // This is a new payment - process it
        //     processPayment(transactionKey);
        // }
        const transactionKey = `payment_${product.productId}_${phoneNumber}`;
        processPayment(transactionKey);
    }, []);
    let globalDialogContainer = null;

    // Exit page when it's not in the foreground (security measure)
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                // Abort all ongoing requests
                if (abortControllerRef.current) {
                    abortControllerRef.current.abort();
                }
                if(globalDialogContainer){
                    globalDialogContainer.remove();
                    globalDialogContainer = null;
                }
                // Navigate away
                navigate('/', { replace: true });
            }
        };

        // Add event listener for visibility change
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup listener on component unmount
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            // Abort any ongoing requests when component unmounts
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [navigate]);

    const processPayment = async (transactionKey) => {
        let step = 0;
        let operation = null;
        let refNumber = null;
        let operationValidated = false;
        let operationSucess = false;

        // Create AbortController for this payment process
        abortControllerRef.current = new AbortController();
        const signal = abortControllerRef.current.signal;
        let responseData = "0"
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            operation = await createOperationRequest(product, phoneNumber, token, setError, setLoading, setPaymentStatus, location_required)
            switch (operation.status) {
                case 0:
                    setError('فشلت العملية');
                    setLoading(false);
                    setPaymentStatus('failed');
                    return;
                case 1:
                    setPaymentStatus('success');
                    setLoading(false);
                    return;
                case -3:
                    // let waitingTime = operation.seconds ?? 5; 
                    // setError(
                    //     'لتفادي تكرار العمليات، لا يمكن اجراء عملية للرقم '+phoneNumber+' مع العرض '+product.productName+' بقيمة '+product.finalPrice+' درهم، يرجى الانتظار لمدة ' + waitingTime + ' ثواني قبل المحاولة مرة أخرى.\n يمكنك شحن عرض أخر أو رقم آخر في هذه الأثناء.'
                    // );
                    // setLoading(false);
                    // setPaymentStatus('failed');
                    // return;
                    let userChoice = false;
                    await new Promise((resolve) => {
                        globalDialogContainer = document.createElement('div');
                        globalDialogContainer.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:9999';

                        const dialog = document.createElement('div');
                        dialog.style.cssText = 'background:white;padding:24px;border-radius:12px;box-shadow:0 4px 12px rgba(0,0,0,0.15);max-width:400px;animation:slideIn 0.3s ease-out';
                        dialog.innerHTML = `
                        <h2 style="margin:0 0 16px 0;font-size:18px;color:#333">تأكيد العملية</h2>
                        <p style="margin:0 0 24px 0;color:#666;line-height:1.5">لاحظنا أنك قمت بإنشاء عملية دفع لنفس المنتج و الرقم من قبل، هل ترغب في تكرار العملية؟</p>
                        <div style="display:flex;gap:12px;justify-content:flex-end">
                            <button id="cancel-btn" style="padding:10px 20px;border:1px solid #ddd;background:#f5f5f5;border-radius:6px;cursor:pointer;font-size:14px">إلغاء</button>
                            <button id="confirm-btn" style="padding:10px 20px;border:none;background:#FF3700;color:white;border-radius:6px;cursor:pointer;font-size:14px">تكرار العملية</button>
                        </div>
                        <style>@keyframes slideIn { from { transform: translateY(-20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }</style>
                    `;

                        globalDialogContainer.appendChild(dialog);
                        document.body.appendChild(globalDialogContainer);

                        document.getElementById('confirm-btn').addEventListener('click', () => {
                            userChoice = true;
                            globalDialogContainer.remove();
                            resolve();
                        });

                        document.getElementById('cancel-btn').addEventListener('click', () => {
                            userChoice = false;
                            globalDialogContainer.remove();
                            resolve();
                        });
                    });
                    console.log("User choice:", userChoice);
                    if (userChoice) {
                        console.log("User chose to continue, creating forced operation request");
                        operation = await createOperationRequest(product, phoneNumber, token, setError, setLoading, setPaymentStatus, location_required, true)
                        switch (operation.status) {
                            case 0:
                                setError('فشلت العملية');
                                setLoading(false);
                                setPaymentStatus('failed');
                                return;
                            case 1:
                                setPaymentStatus('success');
                                setLoading(false);
                                return;
                        }
                    }
            }
            if (operation.status !== -2) {

                setError('حدثت مشكلة أثناء إنشاء العملية، يرجى المحاولة مرة أخرى.');
                setLoading(false);
                setPaymentStatus('failed');
                return;
            }
            step = 1;
            const operationId = operation.id;
            const operationToken = operation.token;
            let paymentHeaders = {
                'Authorization': `Bearer ${operationToken}`,
                "mdn-segmentation-token": "Bearer " + operation.mdnSegmentationToken,
                "referer": "https://inwi.ma/",
                "origin": "https://inwi.ma",
                "accept-encoding": "gzip, deflate, br, zstd",
                "User-Agent": "Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Mobile Safari/537.36', 'Content-Type'to 'application/json",
                "sdata": "eyJjaGFubmVsIjoid2ViIiwiYXBwbGljYXRpb25fb3JpZ2luIjoibXlpbndpIiwidXVpZCI6IjczNWM4OTNlLTY5MDUtNGE4YS04MzNlLTRjOTgxYzkxNDg1MCIsImxhbmd1YWdlIjoiZnIiLCJhcHBWZXJzaW9uIjoxfQ==",
            }
            let cart = await axios.post("https://api.inwi.ma/api/v1/ms-payment/cart/create", {}, {
                headers: paymentHeaders,
                signal: signal
            }).then(res => res.data);
            step = 2;
            const cartResponse = await axios.post(`https://api.inwi.ma/api/v1/ms-payment/cart/add`, {
                productId: product.productId,
                qty: 1,
                cartId: cart.CartId,
                custom_options: [
                    {
                        name: "mdn",
                        value: phoneNumber
                    }
                ]
            }, {
                headers: paymentHeaders,
                signal: signal
            }).then(res => res.data);
            if (cartResponse.status === 200) {
                step = 3
            }
            async function clearCart(cartId, headers) {
                const response = await axios.get(`https://api.inwi.ma/api/v1/ms-payment/cart/pull`, {
                    params: { cartId: cartId },
                    headers: headers
                });

                // Remove each item from cart
                if (response.data && response.data.items) {
                    for (let i = 0; i < response.data.items.length; i++) {
                        await removeItem(cartId, response.data.items[i].itemId, headers);
                    }
                }

                return response.data;
            }

            // Remove individual item from cart
            async function removeItem(cartId, itemId, headers) {
                const response = await axios.post(`https://api.inwi.ma/api/v1/ms-payment/cart/remove`, {
                    cartId: cartId,
                    itemId: itemId
                }, {
                    headers: headers
                });

                return response.data;
            }

            const response = await axios.post(`https://api.inwi.ma/api/v1/ms-payment/recharge/etoile9`, {
                cartId: cart.CartId,
                items: [],
            }, {
                headers: paymentHeaders,
                signal: signal
            }).then(res => res.data);
            // await clearCart(cart.CartId, paymentHeaders);
            refNumber = response.refNumber;
            if (refNumber) {
                responseData = "1"
                step = 4;
                operationSucess = true;
            }

            await axios.post("https://rechargemoi.ma/backend/api/operations/" + operationId, {
                refNumber: refNumber,
                success: refNumber ? 1 : 0,
                response: refNumber ? response : response
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                signal: signal
            });
            operationValidated = true;
            paymentHeaders = null
            cart = null
            // Check if payment was successful
            if (responseData == "1") {
                setPaymentStatus('success');

                // Store transaction data in session storage
                sessionStorage.setItem(transactionKey, JSON.stringify({
                    status: 'success',
                    timestamp: new Date().toISOString()
                }));
            } else {
                setPaymentStatus('failed');
                const errorMessage = 'تعذر معالجة الدفع. يرجى المحاولة مرة أخرى.';
                setError(errorMessage);

                // Store transaction data in session storage
                sessionStorage.setItem(transactionKey, JSON.stringify({
                    status: 'failed',
                    error: errorMessage,
                    timestamp: new Date().toISOString()
                }));
            }

            setPaymentAttempted(true);
            setLoading(false);
        } catch (err) {
            // If request was aborted, just return without any action
            // if (err.name === 'AbortError' || err.name === 'CanceledError') {
            //     console.log('Payment requests aborted due to page visibility change');
            //     return;
            // }
            handleGoToHome();

            // if(!operationValidated && operation){
            //     try {
            //         const token = localStorage.getItem('token');
            //         await axios.post("https://rechargemoi.ma/backend/api/operations/"+operation.id, {
            //             refNumber: refNumber,
            //             success: responseData === "1" ? 1 : 0,
            //             response : err?.data ?? err?.response?.data ?? err?.response?.status
            //         }, {
            //             headers: {
            //                 'Authorization': `Bearer ${token}`,
            //             },
            //             signal: signal
            //         });
            //     } catch (validationErr) {
            //         // Ignore validation errors if aborted
            //         if (validationErr.name !== 'AbortError' && validationErr.name !== 'CanceledError') {
            //             console.error('Validation error:', validationErr);
            //         }
            //     }
            // }
            // setPaymentStatus(responseData === "1" ? 'success' : 'failed');
            // setLoading(false);

            //     setPaymentStatus('failed');
            //     let errorMessage = 'حدث خطأ أثناء معالجة الدفع.';
            //     if(err.response.status === 503){
            //        errorMessage = 'لا يوجد رصيد كاف لاجراء هده العملية يرجى المحاولة لاحقا.';
            //     }
            //     setError(errorMessage);
            //     if(operation && !operationValidated){
            //         const token = localStorage.getItem('token');
            //         await validateOperation(operation.id,token,refNumber,err);
            //     }
            //     if (transactionKey) {
            //         sessionStorage.setItem(transactionKey, JSON.stringify({
            //             status: 'failed',
            //             error: errorMessage,
            //             timestamp: new Date().toISOString()
            //         }));
            //     }

            //     setPaymentAttempted(true);
            //     setLoading(false);
            // }
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleGoToHome = () => {
        navigate('/');
    };

    const handleTryAgain = () => {
        // Generate a transaction key
        const transactionKey = `payment_${product.productId}_${phoneNumber}`;

        // Remove the previous transaction record to allow a retry
        sessionStorage.removeItem(transactionKey);

        // Reset the payment initiated flag to allow retry
        paymentInitiatedRef.current = false;

        // Process the payment again
        processPayment(transactionKey);
    };

    if (loading) {
        return <Spinner overlay={true} textContent="جاري معالجة الدفع..." />;
    }
    if (!loading && paymentStatus) {
        setTimeout(() => {
            navigate('/result', { replace: true, state: { product: product, paymentStatus: paymentStatus, phoneNumber: phoneNumber, error: error } });
        }, 0);
    }
    // If page is reopened but payment wasn't attempted yet
    // if (!paymentAttempted && !loading && !paymentStatus) {
    //     return (
    //         <div className="payment-container" dir="rtl">
    //             <div className="payment-card">
    //                 <h2>صفحة الدفع</h2>
    //                 <div className="payment-warning">
    //                     <div className="warning-icon">⚠️</div>
    //                     <h3>تحذير من تكرار الدفع</h3>
    //                     <p>لقد أعدت فتح صفحة الدفع. لتجنب الرسوم المزدوجة، تم إيقاف معالجة الدفع مؤقتًا.</p>
    //                     <div className="button-group">
    //                         <button 
    //                             className="payment-button try-again-button"
    //                             onClick={handleTryAgain}
    //                         >
    //                             متابعة الدفع
    //                         </button>
    //                         <button 
    //                             className="payment-button back-button"
    //                             onClick={handleGoBack}
    //                         >
    //                             رجوع
    //                         </button>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    return (
        <div className="payment-container" dir="rtl">
            <div className="payment-card">
                <h2>معالجة الدفع</h2>

                {paymentStatus === 'success' && (
                    <div className="payment-success">
                        <div className="success-icon">✓</div>
                        <h3>تم الدفع بنجاح!</h3>
                        <p>تم اكتمال عملية الشحن للرقم {phoneNumber}.</p>
                        <p className="product-info">
                            {product.productName} - {product.finalPrice} درهم
                        </p>
                        <button
                            className="payment-button back-button"
                            onClick={handleGoToHome}
                        >
                            العودة إلى الصفحة الرئيسية
                        </button>
                    </div>
                )}

                {paymentStatus === 'failed' && (
                    <div className="payment-failed">
                        <div className="failed-icon">✕</div>
                        <h3>فشلت عملية الدفع</h3>
                        <p>{error}</p>
                        <div className="button-group">
                            <button
                                className="payment-button try-again-button"
                                onClick={handleTryAgain}
                            >
                                حاول مرة أخرى
                            </button>
                            <button
                                className="payment-button back-button"
                                onClick={handleGoBack}
                            >
                                رجوع
                            </button>
                        </div>
                    </div>
                )}

                {!paymentStatus && (
                    <div className="payment-initializing">
                        <p>جاري بدء عملية الدفع...</p>
                    </div>
                )}
            </div>
        </div>
    );
}
export default PaymentPage;
